export default __webpack_public_path__ + "static/media/par4.d38c1065.jpg";